<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>

        <v-alert  :value="true"  v-if="error != null" type="error" >{{ error.message }}</v-alert>
        <v-alert  :value="true"  v-if="success != null" type="success" >{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" lazy-validation @submit="login">

            <v-text-field outline v-model="username" :rules="usernameRules" label="Email" required></v-text-field>

            <v-layout row align-center mx-1>
              <router-link class="text-button" to="/confirm">Submit an existing verification code</router-link>
              <v-spacer />
              <button type="submit" class="button" :disabled="!valid" color="success">Send Verification Link</button>
            </v-layout>


          </v-form>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'SendConfirmCodeForm',
  data () {
    
    return {
      valid: true,
      usernameRules: [
        v => !!v || 'Email address is required',
        v => (v && v.length > 0) || 'Please enter a valid email address',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      username: '',
      error: null,
      success: null,
      loading: false
    }
  },
  mounted () {
        console.log('Login component loaded')
  },
  methods: {
    login(e) {
        e.preventDefault()
        this.loading = true
        var email = this.username

        this.$resendConfirmationCode(email).subscribe((data) => {
            console.log('send new code request success');
            this.$router.push("/post-registration-message");
        }, 
        (err)=> {
            //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
            console.log(err);
            this.error = err
            if(err.code === "UnknownError"){
                this.$router.push("/login-set-password");
            }
        this.emailVerificationMessage = true;
        });

    }
  }
}
</script>

<style scoped>
</style>